import { Component, Input } from '@angular/core';
@Component({
    selector: 'kh-merge-account-preview',
    styleUrls: ['./merge-account-preview.component.less'],
    templateUrl: './merge-account-preview.component.html',
    standalone: false
})
export class MergeAccountPreviewComponent {

  @Input() public targetEmail = '';
  @Input() public targetDisplayName = '';
  @Input() public sourceEmail = '';
  @Input() public sourceDisplayName = '';

}
